import React from 'react';

import Select from '../../../../components/Inputs/Select';

import * as S from '../styles';

export default function Header({ title, periodFilter, setPeriodFilter }) {
    function handleChange(event) {
        const { value, lookup } = event;

        setPeriodFilter({ ...periodFilter, value, lookup });
    }

    return (
        <S.CustomHeader>
            <S.TitleHeader>{title}</S.TitleHeader>
            <Select field={periodFilter} hasDefaultOption={false} onChange={handleChange} />
        </S.CustomHeader>
    );
}
